import React from 'react';

export function JobCompositeContract() {

	return <React.Fragment>

		{/* This doesn't belong here in the hierarchy but providing it for reference */}
		{/* <div className="alerts">
			<section className="alert attention"><span>You’re viewing a Composite Contract</span></section>
		</div> */}

		<section className="workflowMenu">
			<header><button className="popup disabled"><span><span title="Estimate 1">Estimate 1</span></span></button></header>
			<div>
				<div className="stats clearfix">
					{/* Note inline green background color and appended ' - Composite' string on badge */}
					<div className="cost column">$25.7K<span>TOTAL</span><span className="badge" style={{ backgroundColor: 'rgb(98, 151, 40)'}}><span>L - Composite</span></span></div>
				</div>
				<div className="referenceNumbers">JC-1</div>
				<div className="scrollable">
					<ul className="menu">
						<li><a className="button hasChange hasData locked on" title="Setup"><span>Setup</span><em className="status"></em></a></li>
						<li><a className="button locked" title="Referral Fee"><span>Referral Fee</span><em className="status"></em></a></li>
						<li><a className="button hasData locked" title="Work Area Specs"><span>Work Area Specs</span><em className="status"></em></a></li>
						<li><a className="button hasData locked" title="Accessories &amp; Mods"><span>Accessories &amp; Mods</span><em className="status"></em></a></li>
						<li><a className="button hasData locked" title="Appliance Specs"><span>Appliance Specs</span><em className="status"></em></a></li>
						<li><a className="button hasData locked" title="Cabinet Cost"><span>Cabinet Cost</span><em className="status"></em></a></li>
						<li><a className="button hasData locked" title="Glass"><span>Glass</span><em className="status"></em></a></li>
						<li><a className="button locked" title="Solid Surface Counter"><span>Solid Surface Counter</span><em className="status"></em></a></li>
						<li><a className="button locked" title="Sub Trades"><span>Sub Trades</span><em className="status"></em></a></li>
						<li><a className="button locked" title="Summary"><span>Summary</span><em className="status"></em></a></li>
						<li><a className="button locked" title="Reports"><span>Reports</span><em className="status"></em></a></li>
					</ul>
				</div>
			</div>
		</section>	
		
		<section className="workflow">
			<section>
				<header><span>Panel Here <span className="options"></span></span>
					<div className="actions"></div>
				</header>
				<div>
					<section>
						<header></header>
						<div className="inner">
							Content here
						</div>
					</section>
				</div>
			</section>
		</section>

	</React.Fragment>;
}